import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Logo = () => (
  <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
      <rect x="1" y="1" width="24" height="24" stroke="#00F0FF" strokeWidth="1.5" />
      <path d="M1 13 H13 V25 M13 13 L25 1" stroke="#00F0FF" strokeWidth="1.5" />
      <circle cx="13" cy="13" r="2" fill="#FFB800" />
    </svg>
    <span className="font-display font-bold tracking-tight text-[15px]">RhinoDraft<span className="text-[var(--cyan)]"> AI</span></span>
  </Link>
);

export const AppHeader = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="glass sticky top-0 z-30 border-b border-[var(--line)] h-14 px-4 sm:px-6 flex items-center gap-4">
      <Logo />
      <div className="flex-1 min-w-0 flex items-center gap-3">{children}</div>
      {user && (
        <div className="flex items-center gap-3">
          {user.picture ? <img src={user.picture} alt="" className="w-7 h-7 rounded-full" /> : (
            <span className="w-7 h-7 grid place-items-center bg-[var(--card)] border border-[var(--line)] text-xs font-mono">{user.name?.[0]?.toUpperCase()}</span>
          )}
          <span className="hidden md:block text-sm text-[var(--muted)]" data-testid="header-user-name">{user.name}</span>
          <button data-testid="logout-btn" onClick={async () => { await logout(); navigate("/"); }} className="text-[var(--muted)] hover:text-white transition-colors" title="Sign out"><LogOut size={16} /></button>
        </div>
      )}
    </header>
  );
};
